import React from "react"
import { useTranslation } from "react-i18next"

import { Action } from "shared/types/Action"
import { ActionsOverlay } from "shared/ui/actions-overlay/ActionsOverlay"

export interface FeedbackActionsOverlayViewModel {
  onCancel: () => void
  feedbackActions: Action[]
}

export const FeedbackActionsOverlayView = React.memo(
  ({ onCancel, feedbackActions }: FeedbackActionsOverlayViewModel) => {
    const { t } = useTranslation()
    return (
      <ActionsOverlay
        id="feedback-actions-overlay"
        headline={t("Feedback.ChooseType")}
        actions={feedbackActions}
        onCancel={onCancel}
      />
    )
  }
)
